export default __webpack_public_path__ + "static/media/S100_1.7664c2dd.gif";